import "../../static/js/locale.js";
import "../../static/js/strings.js";
import "../../static/js/i18n.js";
import "../../static/js/login.js";
